import { DateHelper } from "app/core/helpers/date.helper";

export class FormValidatorConfig {
  public static readonly ALL_YEAR_LIST: number[] = DateHelper.createListOfYearsBetween();
  public static readonly TO_2023_YEAR: number[] = DateHelper.createListOfYearsBetween(2016, 2023);
  public static readonly FROM_2024: number[] = DateHelper.createListOfYearsBetween(2024);
}
